import { render, staticRenderFns } from "./StockAllocatedOpenJobs.vue?vue&type=template&id=608137a8&scoped=true&"
import script from "./StockAllocatedOpenJobs.vue?vue&type=script&lang=js&"
export * from "./StockAllocatedOpenJobs.vue?vue&type=script&lang=js&"
import style0 from "./StockAllocatedOpenJobs.vue?vue&type=style&index=0&id=608137a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608137a8",
  null
  
)

export default component.exports